module.exports = __webpack_public_path__ + "img/face-frown-open.b6a00401.svg";